import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { setLogout } from 'state';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();

    useEffect(() => {
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                const currentTime = Date.now() / 1000;
                
                // Check if the token has expired
                if (decodedToken.exp < currentTime) {
                    dispatch(setLogout());
                }
            } catch (error) {
                console.error("Token decode error:", error);
                dispatch(setLogout());
            }
        }
    }, [token, dispatch]);

    return (
        <AuthContext.Provider value={{ token }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
